import React, { FC } from "react"
import type { BlackoutDate } from "../../Api/BlackoutDateApi"

interface BlackoutListProps {
  blackoutDates: BlackoutDate[]
  currentMonth: Date
  onEdit: (blackout: BlackoutDate) => void
  onDelete: (id: number) => void
}

const BlackoutList: FC<BlackoutListProps> = ({
  blackoutDates,
  currentMonth,
  onEdit,
  onDelete
}) => {
  // 現在の月の範囲を計算
  const year = currentMonth.getFullYear()
  const month = currentMonth.getMonth()
  const firstDay = new Date(year, month, 1)
  firstDay.setHours(0, 0, 0, 0)
  const lastDay = new Date(year, month + 1, 0)
  lastDay.setHours(23, 59, 59, 999)
  
  const formatDateForDisplay = (dateString: string): string => {
    const [dateYear, dateMonth, dateDay] = dateString.split('-').map(Number)
    const date = new Date(dateYear, dateMonth - 1, dateDay)
    const weekdays = ['日', '月', '火', '水', '木', '金', '土']
    const weekday = weekdays[date.getDay()]
    
    return `${dateYear}年${dateMonth}月${dateDay}日(${weekday})`
  }
  
  // 現在の月の予約不可日のみをフィルタリング
  const filteredBlackoutDates = blackoutDates.filter(b => {
    if (!b.is_active) return false
    const blackoutDate = b.date ? (b.date.includes('T') ? b.date.split('T')[0] : b.date) : ''
    const [yearStr, monthStr, dayStr] = blackoutDate.split('-').map(Number)
    const blackoutDateObj = new Date(yearStr, monthStr - 1, dayStr)
    blackoutDateObj.setHours(0, 0, 0, 0)
    return blackoutDateObj >= firstDay && blackoutDateObj <= lastDay
  })
  
  if (filteredBlackoutDates.length === 0) {
    return (
      <div className="text-center py-12 px-4 text-gray-400">
        <svg className="w-16 h-16 mx-auto mb-4 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
        </svg>
        <p>{year}年{month + 1}月の予約不可日が設定されていません</p>
      </div>
    )
  }
  
  return (
    <div className="flex flex-col gap-3">
      {filteredBlackoutDates.map((blackout) => (
        <div
          key={blackout.id}
          className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border border-gray-200 transition-all hover:border-blue-500 hover:shadow-sm"
        >
          <div className="flex-1 flex gap-6 items-center">
            <div className="font-semibold text-gray-900 min-w-[150px]">
              {formatDateForDisplay(blackout.date)}
            </div>
            <div className="text-gray-600 text-sm">
              {blackout.reason || '理由なし'}
            </div>
          </div>
          <div className="flex gap-2">
            <button
              className="inline-flex items-center justify-center px-3 py-1.5 bg-gray-100 text-gray-900 border border-gray-200 rounded-lg text-sm font-medium hover:bg-gray-200 transition-all"
              onClick={() => onEdit(blackout)}
            >
              編集
            </button>
            <button
              className="inline-flex items-center justify-center px-3 py-1.5 bg-red-500 text-white rounded-lg text-sm font-medium hover:bg-red-600 transition-all"
              onClick={() => {
                onDelete(blackout.id)
              }}
            >
              削除
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default BlackoutList

